// extracted by mini-css-extract-plugin
module.exports = {"banner":"HBETKb","content":"_2TfwC6","closeButton":"u16D-W","bannerText":"_1n84aV","button":"_3hk20m"};